// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LazyImage-module--wrapper--3BMq2","image":"LazyImage-module--image--2igMK","loaded":"LazyImage-module--loaded--1ObAk"};